import { EnumOption } from "./enum-option"

export const AlertType = {
    CaseReceiptsExpiration: 0,    
    MatterExpiration: 1, 
    FilingDeadlineDate: 2, 
    I94: 3, 
    I797: 4, 
    Passport:5,
    MaximumValidityPeriodofHorLStatus: 6,
    EAD: 7,
    AdvanceParoleDate: 8,
    GreenCard: 9,
    ReentryPermitInfo: 10,
    DS2019: 11,
    EADAPD: 12,
    Visa: 13,
    NaturalizationEligibilityDate: 14,
    I751: 15,
}

export const AlertTypeList: EnumOption[] = [
    { value: AlertType.CaseReceiptsExpiration, label: 'Case Receipts Expiration' },    
    { value: AlertType.MatterExpiration, label: 'Matter (case) Expiration' },
    { value: AlertType.FilingDeadlineDate, label: 'Filing Deadline Date' },
    { value: AlertType.I94, label: 'I-94' },
    { value: AlertType.I797, label: 'I-797' },
    { value: AlertType.Passport, label: 'Passport' },
    { value: AlertType.MaximumValidityPeriodofHorLStatus, label: 'Maximum Validity Period of H or L Status' },
    { value: AlertType.EAD, label: 'EAD' },
    { value: AlertType.AdvanceParoleDate, label: 'Advance Parole Date' },
    { value: AlertType.GreenCard, label: 'Green Card' },
    { value: AlertType.ReentryPermitInfo, label: 'Re-entry Permit Info' },
    { value: AlertType.DS2019, label: 'DS-2019' },
    { value: AlertType.EADAPD, label: 'EAD/APD' },
    { value: AlertType.Visa, label: 'Visa' },
    { value: AlertType.NaturalizationEligibilityDate, label: 'Eligibility Date For Naturalization' },
    { value: AlertType.I751, label: 'I-751' }
]
